import { render, staticRenderFns } from "./kvNoteList.vue?vue&type=template&id=3c83f0c7&scoped=true&"
import script from "./kvNoteList.vue?vue&type=script&lang=js&"
export * from "./kvNoteList.vue?vue&type=script&lang=js&"
import style0 from "./kvNoteList.vue?vue&type=style&index=0&id=3c83f0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83f0c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c83f0c7')) {
      api.createRecord('3c83f0c7', component.options)
    } else {
      api.reload('3c83f0c7', component.options)
    }
    module.hot.accept("./kvNoteList.vue?vue&type=template&id=3c83f0c7&scoped=true&", function () {
      api.rerender('3c83f0c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/kvNoteList.vue"
export default component.exports